/**
 * AiUsageBadge — small persistent pill indicating the current month's AI credit
 * consumption (see server GET /api/ai/usage, server/aiUsageLimiter.js).
 *
 * Rendered in AppShell's top bar, next to the current project name. Renders
 * nothing for free-tier users (limit is 0 — AI features are already locked
 * elsewhere) or before the first fetch completes, so it never flashes a
 * misleading state on load. Shows the "AI Usage" label alongside the actual
 * creditsUsed/creditLimit count; the tooltip adds the reset period.
 */
import { useStore } from '../store/useStore';

export function AiUsageBadge() {
    const aiUsage = useStore((s) => s.aiUsage);

    if (!aiUsage) return null;

    if (aiUsage.unlimited) {
        return (
            <span className='ai-usage-badge' title='Zeytune team account — unlimited AI usage'>
                AI Usage: Unlimited
            </span>
        );
    }

    if (aiUsage.creditLimit <= 0) return null;

    return (
        <span
            className='ai-usage-badge'
            title={`AI credits used this month, resets next month (period ${aiUsage.period})`}
        >
            AI Usage: {aiUsage.creditsUsed}/{aiUsage.creditLimit}
        </span>
    );
}
